export const HIT_INDEX_VIEW = "HIT_INDEX_VIEW";
export const GET_INDEX_VIEW = "GET_INDEX_VIEW";

export const HIT_CREATE_BS = "HIT_CREATE_BS";
export const GET_CREATE_BS = "GET_CREATE_BS";

export const HIT_DETAIL_BS = "HIT_DETAIL_BS";
export const GET_DETAIL_BS = "GET_DETAIL_BS";

export const GET_INDEX_VIEW_SEARCH = "GET_INDEX_VIEW_SEARCH";

export const HIT_CREATE_CHILD = "HIT_CREATE_CHILD";
export const GET_CREATE_CHILD = "GET_CREATE_CHILD";

export const HIT_UPDATE_BS = "HIT_UPDATE_BS";
export const GET_UPDATE_BS = "GET_UPDATE_BS";

export const HIT_HIERARCHY = "HIT_HIERARCHY";
export const GET_HIERARCHY = "GET_HIERARCHY";

export const HIT_TREE_VIEW = "HIT_TREE_VIEW";
export const GET_TREE_VIEW = "GET_TREE_VIEW";

export const HIT_ADD_TREE = "HIT_ADD_TREE";
export const GET_ADD_TREE = "GET_ADD_TREE";

export const HIT_MOVE_TREE = "HIT_MOVE_TREE";

export const HIT_IMPORT_PROCESS = "HIT_IMPORT_PROCESS";

export const HIT_APQC_VER = "HIT_APQC_VER";
export const GET_APQC_VER = "GET_APQC_VER";
export const HIT_APQC_LIB = "HIT_APQC_LIB";
export const GET_APQC_LIB = "GET_APQC_LIB";
export const HIT_APQC_TEMPLATE = "HIT_APQC_TEMPLATE";
export const GET_APQC_TEMPLATE = "GET_APQC_TEMPLATE";
export const HIT_ADD_APQC = "HIT_ADD_APQC";

export const HIT_DELETE_PROCESS = "HIT_DELETE_PROCESS";

export const HIT_IMPORT_PROCESS_COPY = "HIT_IMPORT_PROCESS_COPY";
export const HIT_LIST_PROCESS_LEVEL = "HIT_LIST_PROCESS_LEVEL";
export const GET_LIST_PROCESS_LEVEL = "GET_LIST_PROCESS_LEVEL";

export const UPDATE_LEVEL_PROCEESS_PARENT = "UPDATE_LEVEL_PROCEESS_PARENT";
